<template lang='pug'>
	.viewer.swiper-no-swiping
		.map(ref='map')
</template>

<script>
import gmapsInit from '@/lib/gmaps';
import GoogleMapsStyles from '@/assets/google-maps-styles';

export default {
	name : 'map-viewer',

	props : {
		location : {
			type    : Object,
			default : () => ( {
				lat : 36.726081,
				lng : -119.789243,
			} ),
		},

		zoom : {
			type    : Number,
			default : 12,
		},

		pin : {
			type    : Object,
			default : null,
		},

		pinIcon : {
			type    : String,
			default : '/img/pins/job.svg',
		}
	},

	data : () => ( {
		client : null,
		map    : null,
		google : null,
	} ),

	async mounted() {
		if ( !this.google ) {
			// initialize the google maps client
			this.google = await gmapsInit();

			const map = this.createMap( this.google );

			this.$emit( 'ready', map );

			return;
		}

		const map = this.createMap( this.google );

		this.$emit( 'ready', map );
	},

	methods : {

		createMap( google ) {

			// initialize the map
			const { map }      = this.$refs;
			const { lat, lng } = this.location;
			this.map = new google.maps.Map( map, { // eslint-disable-line
				center           : new google.maps.LatLng( lat, lng ), // eslint-disable-line
				styles           : GoogleMapsStyles,
				zoom             : this.zoom,
				disableDefaultUI : true,
			} );

			// initialize the event listeners
			this.map.addListener( 'click', ( e ) => {
				// eslint-disable-next-line no-shadow
				const { lat, lng } = e.latLng;

				this.$emit( 'click', {
					location : {
						lat : lat(),
						lng : lng(),
					}
				} );
			} );

			// initialize zoom event listener
			this.map.addListener( 'zoom_changed', () => {
				const zoom = this.map.getZoom();

				this.$emit( 'zoom', zoom );
			} );

			const observer = new MutationObserver( () => {

				document.querySelectorAll( '.map a' ).forEach( ( link ) => {

					link.setAttribute( 'tabindex', '-1' );

				} );

			} );

			observer.observe( this.$refs.map, {
				subtree   : true,
				childList : true,
			} );

			// add pin if necessary
			if ( this.pin ) {
				this.setMarker( this.pin );
			}

			return this.map;
		},

		createIconObject : url => ( {
			url,
			scaledSize : {
				width  : 104,
				height : 113,
			},
			anchor : {
				x : 52,
				y : 77,
			},
		} ),

		setMarker( pin ) {
			const { pinIcon : icon } = this;

			if ( this.marker ) {
				// remove the marker
				this.marker.setMap( null );
			}

			// set the marker
			const marker = new google.maps.Marker( { // eslint-disable-line
				position : pin,
				map      : this.map,
				icon     : this.createIconObject( icon ),
			} );
			// 'e' was removed as an argument from the below arrow function since it's value is never used.
			marker.addListener( 'click', () => {
				// console.log( marker );
				this.$emit( 'remove-pin', marker );
				marker.setMap( null );
			} );

			this.marker = marker;
		},

	},

	watch : {

		location : {
			deep : true,
			handler( loc ) {
				if ( !this.map ) {
					return;
				}

				const { lat, lng } = loc;

				this.map.setCenter( new this.google.maps.LatLng( lat, lng ) );
			}
		},

		pin : {
			deep : true,
			handler( pin ) {
				if ( !pin ) {
					return;
				}

				this.setMarker( pin );

			}
		},

		zoom : {
			immediate : true,
			handler( zoom ) {
				if ( this.map && zoom !== this.map.getZoom() ) {
					this.map.setZoom( zoom );
				}
			}
		}
	},

};
</script>

<style lang='scss'>
.viewer {
	width: 100%;
	border-radius: 15px;
	overflow: hidden;

	.map {
		height: 300px;
		width: 100%;

		>div:nth-child(2) {
			z-index: 2!important;
		}
	}
}
</style>
